<template>
  <element>
  <panel>
    <el-form>
      <el-row>
        <el-col :span="12">
          <el-form-item label="挂靠公司：">
            {{customerDetail.ix__extCompany}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="挂靠单位法人：">
            {{customerDetail.ix__extCompanyBizRep}}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="挂靠单位地址：">
            {{customerDetail.ix__extCompanyAddress}}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </panel>
  <panel label="证件图片" class="zhengjianxinxi">
    <photo-browser v-model="customerDetail.ix__extCompanyLicense" label="营业执照"/>
    <photo-browser v-model="customerDetail.ix__extCompanyBizRepIC" label="法人代表身份证"/>
    <photo-browser v-model="customerDetail.ix__extCompanyRoadLicense" label="道路运输许可证"/>
  </panel>
  </element>
</template>

<script>
  export default {
    name: "CustomerDetailExtCompanyComponent",
    data() {
      return {}
    },
    props:{
      value: {
        type: Object
      }
    },
    computed: {
      customerDetail: {
        get: function () {
          return this.value
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerDetailExtCompanyComponent.vue